import {useState} from "react";


function UserCounter(init) {
    const [count, setCount] = useState(init=0)

    function increas() {
        setCount((pre)=>pre+1)
    }

    function decreas() {
        setCount((pre)=>pre-1)
    }
    function reset() {
        setCount(0)
    }


    return [count,increas,decreas,reset]
}

export default UserCounter
